export default class fbDateFieldCtrl {
  constructor($element, $timeout, DateParserServ) {
    this.element = $element[0]
    this.timeout = $timeout
    this.dateParserServ = DateParserServ
    this.submit = this.submit.bind(this)
    this.newDate = ''
    this.editMode = false
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleTab = this.handleTab.bind(this)
  }
  $onInit() {
    /*
      Called on each controller after all the controllers on an element 
      have been constructed and had their bindings initialized 
      (and before the pre & post linking functions for the directives on this 
      element). This is a good place to put initialization code for your controller.
    */
    this.fromFact(this.fbDateish)
    this.element.addEventListener('keyup', this.handleTab)

  }
  $onDestroy() {
    /*
      Called on a controller when its containing scope is destroyed. 
      Use this hook for releasing external resources, watches and event handlers.
    */
  }
  $onChanges({fbDateish}) {
    /*
      Called whenever one-way bindings are updated. The changesObj is a hash 
      whose keys are the names of the bound properties that have changed, and 
      the values are an object of the form 
      { currentValue, previousValue, isFirstChange() }. 
      Use this hook to trigger updates within a component such as cloning the 
      bound value to prevent accidental mutation of the outer value.
    */
    if (fbDateish.currentValue !== fbDateish.previousValue) {
      this.fromFact(fbDateish.currentValue)
    }
  }
  fromFact(factDateish) {
    this.parsedDate = this.dateParserServ.fromFactDateish(factDateish)
    this.isValid = this.dateParserServ.validate(this.parsedDate);
    this.formattedDate = this.dateParserServ.format(this.parsedDate);
    this.newDate = this.formattedDate;
  }
  update() {
    this.parsedDate = this.dateParserServ.parse(this.newDate);
    this.isValid = this.dateParserServ.validate(this.parsedDate);
    this.formattedDate = this.dateParserServ.format(this.parsedDate);
  }
  handleTab(e) {
    if (e && e.type === 'keyup' && e.keyCode === 9) { // tab
      this.timeout(()=>{this.setEditMode(true)}, 0)
    }
  }
  handleBlur(e) {
    this.timeout(()=>{this.handleUpdate(e)}, 0)
  }
  setEditMode(editMode) {
    this.editMode = editMode
    const input = this.element.querySelector('.editable-input')
    if (editMode) {
      this.timeout(() => input.focus())
      input.addEventListener('blur', this.handleBlur)
      this.element.removeEventListener('keyup', this.handleTab)
    } else {
      input.removeEventListener('blur', this.handleBlur)
      this.element.addEventListener('keyup', this.handleTab)
    }
  }
  submit() {
    this.update()
    this.newDate = this.formattedDate;
    this.setEditMode(false)
    if (this.isValid) {
      this.updateFact({factDateish: this.dateParserServ.toFactDateish(this.parsedDate)})
    } else {
      this.$onInit()
    }
  }

  handleUpdate(e) {

    if (!e) {
      return
    }
    switch (e.type) {
      case 'keyup':
        switch (e.keyCode) {
          case 13: // enter
          case 27: // esc
            this.submit()
            break;
          default:
            break
        }
        break
      case 'blur':
        this.submit()
        break
    }
  }
}
fbDateFieldCtrl.$inject = ['$element', '$timeout', 'DateParserServ']



// WEBPACK FOOTER //
// ./project/components/fb-date-field/fb-date-field.controller.js